import axios from "./http";

export const login = data => axios.post("users/self", data);
export const logout = () => axios.delete("users/self");
export const signup = data => axios.put("users/self", data);
export const generateSmsCodeAPI = data => axios.post("users/self/phone", data);
